// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"CustomerListPage_buttonGroup__2MsfC"};